import React from 'react';
import { Card } from 'react-bootstrap';

import FacturasGlobalesStatus from '../../components/FacturasGlobalesStatus';

const FacturasGlobalesTicketGeneralInfo = (props) => {
  const { data = {} } = props;

  return (
    <Card>
      <Card.Body>
        <strong className="text-info card-label-info">Estatus: </strong>
        {<FacturasGlobalesStatus item={data} />}
        <br />
        {data.razon_status && (
          <>
            <strong className="text-info card-label-info">Mensaje: </strong>
            {data.razon_status}
            <br />
          </>
        )}
        <strong className="text-info card-label-info">Sucursal: </strong>
        {data.grupo}
        <br />
        <strong className="text-info card-label-info">Tickets asociados: </strong>
        {data.tickets}
        <br />
        <strong className="text-info card-label-info">Folio Fiscal: </strong>
        {data.cfdi_uuid}
        <br />
        <strong className="text-info card-label-info">Emisor: </strong>
        {data.emisor_rfc}
        <br />
        <strong className="text-info card-label-info">Receptor: </strong>
        {data.receptor_rfc} {data.receptor_razon_social || ''}
        <br />
        <strong className="text-info card-label-info">Total: </strong>
        {data.total}
        <br />
      </Card.Body>
    </Card>
  );
};

export default FacturasGlobalesTicketGeneralInfo;
